import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as moment from "moment"
//import lib
// import { capitalize } from "../../lib/string";

import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';

export const orderPDF = (data: any) => {
    try {
        let resultArr: any[] = [];
        data.map((item: any) => {
            resultArr.push([
                item.email,
                item.name,
                item.aadharProof.aadharNumber,
                item.panProof.panNumber,
                item.panProof.status,
                moment(item.createdAt).format("MMM DD,YYYY,h:mm:ss A")
            ]);
        });
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(10);

        const title = "User Report";
        const headers = [
            [
                "Email",
                "Name",
                "Aadhaar Number",
                "Pan Number",
                "Status",
                "Date"
            ],
        ];

        let content = {
            startY: 50,
            head: headers,
            body: resultArr,
        };
        doc.text(title, marginLeft, 40);
        // doc.autoTable(content);
        // doc.save("User Details.pdf");

        autoTable(doc, { html: '#my-table' })

        autoTable(doc, content)

        doc.save('User Kyc.pdf')
    } catch (err) {
        console.log(err, "err");
    }
};

export const orderCSV = (data: any) => {
    try {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "User Kyc Report.csv");
        document.body.appendChild(link);
        link.click();
    } catch (err) {

    }
};



export const orderXLS = (data: any, wantedFields: string[]) => {
    try {
        // Filter and reshape the data to include only wanted fields
        const filteredData = data.map((item: any) => {
            const filteredItem: any = {};
            wantedFields.forEach((field) => {
                if (field === "createdAt" && item[field]) {
                    // Format the MongoDB date to a readable format
                    filteredItem[field] = moment(item[field]).format("YYYY-MM-DD HH:mm:ss");
                }
                if (field === "adminActionDate" && item[field]) {
                    // Format the MongoDB date to a readable format
                    filteredItem[field] = moment(item[field]).format("YYYY-MM-DD HH:mm:ss");
                }
                else if (item[field] !== undefined) {
                    filteredItem[field] = item[field];
                }
            });
            return filteredItem;
        });

        // Convert the filtered data to an Excel worksheet
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

        // Generate the Excel file
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const fileData = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Download the Excel file
        saveAs(fileData, "User Deposit Commission Report.xlsx");
    } catch (err) {
        console.log(err, "err");
    }
};
